import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';
import { CloseIcon } from './Icons';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../utils/formatPrice';
import { getWhatsAppOrderUrl } from '../utils/orderMessage';

function CartPanel() {
  const {
    items,
    isCartOpen,
    closeCart,
    removeItem,
    updateQuantity,
    clearCart,
    totalCount,
    totalPrice,
  } = useCart();

  if (!isCartOpen) return null;

  const whatsAppOrderUrl = getWhatsAppOrderUrl(items, totalPrice);

  return (
    <div className="cart-overlay" onClick={closeCart} role="presentation">
      <aside
        className="cart-panel"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cart-title"
      >
        <div className="cart-panel-header">
          <div>
            <h2 id="cart-title" className="cart-panel-title">Mon panier</h2>
            <p className="cart-panel-subtitle">{totalCount} article{totalCount > 1 ? 's' : ''}</p>
          </div>
          <button type="button" className="modal-close" onClick={closeCart} aria-label="Fermer le panier">
            <CloseIcon size={22} />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <p>Votre panier est vide.</p>
            <p className="cart-empty-hint">Composez un repas depuis le menu pour commencer.</p>
            <Link to="/menu" className="btn btn-primary cart-empty-btn" onClick={closeCart}>
              Voir le menu
            </Link>
          </div>
        ) : (
          <>
            <ul className="cart-items">
              {items.map((item) => (
                <li key={item.cartId} className="cart-item">
                  <div className="cart-item-image">
                    <OptimizedImage image={item.image} alt="" loading="lazy" />
                  </div>
                  <div className="cart-item-body">
                    <div className="cart-item-top">
                      <h3 className="cart-item-name">{item.name}</h3>
                      <button
                        type="button"
                        className="cart-item-remove"
                        onClick={() => removeItem(item.cartId)}
                        aria-label={`Retirer ${item.name}`}
                      >
                        ×
                      </button>
                    </div>

                    {item.selectedIncluded.length > 0 && (
                      <p className="cart-item-detail">
                        Inclus : {item.selectedIncluded.map((ing) => ing.name).join(', ')}
                      </p>
                    )}
                    {item.selectedExtras.length > 0 && (
                      <p className="cart-item-detail">
                        + {item.selectedExtras.map((extra) => extra.name).join(', ')}
                      </p>
                    )}
                    {(item.selectedDrinks || []).length > 0 && (
                      <p className="cart-item-detail cart-item-detail-drinks">
                        🥤 {(item.selectedDrinks || []).map((drink) => drink.name).join(', ')}
                      </p>
                    )}
                    {item.removedIncluded.length > 0 && (
                      <p className="cart-item-detail cart-item-detail-muted">
                        Sans : {item.removedIncluded.map((ing) => ing.name).join(', ')}
                      </p>
                    )}
                    {item.notes && (
                      <p className="cart-item-detail cart-item-detail-muted">{item.notes}</p>
                    )}

                    <div className="cart-item-footer">
                      <div className="quantity-control quantity-control-sm">
                        <button
                          type="button"
                          onClick={() => updateQuantity(item.cartId, item.quantity - 1)}
                          aria-label="Diminuer"
                        >
                          −
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          type="button"
                          onClick={() => updateQuantity(item.cartId, item.quantity + 1)}
                          aria-label="Augmenter"
                        >
                          +
                        </button>
                      </div>
                      <span className="cart-item-price">{formatPrice(item.lineTotal)}</span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            <div className="cart-panel-footer">
              <div className="cart-total-row">
                <span>Total</span>
                <strong>{formatPrice(totalPrice)}</strong>
              </div>
              <a
                href={whatsAppOrderUrl}
                className="btn btn-primary cart-checkout-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
               Passer Commande — {formatPrice(totalPrice)}
              </a>
              <button type="button" className="cart-clear-btn" onClick={clearCart}>
                Vider le panier
              </button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
}

export default CartPanel;
